import React from 'react';
import { Box } from '@mui/material';

/** The sticky offset from the table's left edge; the same gap is kept on the right. */
export const DETAIL_INSET = '1rem';

/**
 * The detail box is pushed right by DETAIL_INSET, so it must be narrower than the table by the
 * inset on both sides, or its right edge (and right-aligned content) runs past the visible table.
 */
export const detailWidth = (tableWidth: number | undefined): string | 0 =>
  tableWidth ? `calc(${tableWidth}px - 2 * ${DETAIL_INSET})` : 0;

export const RowDetailWrapper = ({ tableId = 'root', children }: any) => {
  const element = document.getElementById(tableId);
  const width = React.useMemo(
    () => detailWidth(element?.offsetWidth),
    [element]
  );
  return (
    <Box
      style={{
        width,
        position: 'sticky',
        left: DETAIL_INSET,
        margin: '0.3rem 0',
      }}
    >
      {children}
    </Box>
  );
};
